import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { listRowConfigShape } from 'app/shapes/browse';
import ListsRow from './ListsRow';

const ListsRowContainer = ({ config }) => {
  const library = useSelector(selectCurrentLibrary);

  return <ListsRow config={config} library={library} />;
};

ListsRowContainer.propTypes = {
  config: listRowConfigShape.isRequired
};

export default ListsRowContainer;
